import { hsdTheme as baseHsdTheme } from "@biesse-group/react-components";
import { DefaultTheme } from "styled-components";

export const hsdTheme: DefaultTheme = {
  ...baseHsdTheme,
  table: {
    borderColor: "#c7c7c7",
  },
};
